import { render, staticRenderFns } from "./create-remap-type-global.vue?vue&type=template&id=35581abd&"
import script from "./create-remap-type-global.vue?vue&type=script&lang=js&"
export * from "./create-remap-type-global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports